import React from 'react';
import { Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  containerStyle: {
    padding: '10px',
  },
});

export default function SharedCases () {
  const classes = useStyles();

  return (
    <Container className={classes.containerStyle}>
      <Typography variant='h6'>Listing my shared cases here</Typography>
    </Container>
  );
}
